import React, {Component} from 'react';
import * as Cards from './cards/index'

import './SummaryBody.css'

class SummaryBody extends Component {
  render() {
    return (
      <div className="summary-body">
	      <div className="card-1"><Cards.CardAccessedLastNDays N={30} /></div>
        <div className="card-2"><Cards.CardMobileUsage /></div>
	      <div className="card-3"><Cards.CardPhoneTabletUsage /></div>
	      <div className="card-4"><Cards.CardLanguageUsage /></div>
      </div>
    );
  }
}

export default SummaryBody;


// WEBPACK FOOTER //
// ./src/components/summary/SummaryBody.jsx